module.exports = __webpack_public_path__ + "static/media/time.1225347c.svg";